var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardHoverBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6468_3881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.418 9.47044L9.4763 23.4121",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0508 6.67129L13.6508 8.07129",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 9.80932L9.12182 12.5977",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 16.0507L16.0532 23.7973C13.5798 26.2707 12.3432 26.2823 9.89315 23.8323L4.16482 18.104C1.71482 15.654 1.72649 14.4173 4.19982 11.944L11.9465 4.19734C14.4198 1.72401 15.6565 1.71234 18.1065 4.16234L23.8348 9.89067C26.2848 12.3407 26.2848 13.5657 23.7998 16.0507Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 10.2358H0V28.0002H12.8333V10.2358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.01995 22.4612L1.11886 21.4913L1.15382 22.8147C1.22063 25.3439 3.62171 27.2599 6.40538 27.2599C9.18905 27.2599 11.5901 25.3439 11.6569 22.8147L11.6921 21.4836L10.7895 22.4626C9.82297 23.5109 8.26137 24.194 6.40538 24.194C4.55056 24.194 2.99587 23.5116 2.01995 22.4612ZM6.40538 27.4995C3.3156 27.4995 0.914062 25.2949 0.914062 22.7106V19.653C0.914062 19.6243 0.925757 19.5943 0.950454 19.5696C0.975152 19.5449 1.00513 19.5332 1.03385 19.5332C1.06258 19.5332 1.09256 19.5449 1.11725 19.5696C1.14195 19.5943 1.15365 19.6243 1.15365 19.653C1.15365 22.1924 3.52826 23.9544 6.40538 23.9544C9.2825 23.9544 11.6571 22.1924 11.6571 19.653C11.6571 19.6243 11.6688 19.5943 11.6935 19.5696C11.7182 19.5449 11.7482 19.5332 11.7769 19.5332C11.8056 19.5332 11.8356 19.5449 11.8603 19.5696C11.885 19.5943 11.8967 19.6243 11.8967 19.653V22.7106C11.8967 25.2949 9.49516 27.4995 6.40538 27.4995Z",
    stroke: "#0008C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50296 17.6294L1.50297 17.6294L1.50168 17.6273C1.12038 17.004 0.914062 16.2763 0.914062 15.5247C0.914062 14.2599 1.47844 13.0543 2.52856 12.1325C3.55439 11.235 4.93046 10.7358 6.40538 10.7358C7.87829 10.7358 9.24707 11.2338 10.2829 12.1248C11.3332 13.0554 11.8967 14.2611 11.8967 15.5247C11.8967 16.2749 11.6911 16.9954 11.3078 17.6294C10.4168 19.1022 8.54982 20.0657 6.40538 20.0657C4.26094 20.0657 2.39399 19.1022 1.50296 17.6294ZM1.70479 17.5019L1.70479 17.5019L1.70589 17.5037C2.6039 18.9783 4.42722 19.8261 6.40538 19.8261C8.38479 19.8261 10.206 18.9693 11.1035 17.5058C11.4769 16.9024 11.6571 16.2323 11.6571 15.5247C11.6571 14.3079 11.1039 13.1675 10.1236 12.3063L10.1236 12.3063L10.1201 12.3033C9.12162 11.4422 7.80491 10.9754 6.40538 10.9754C5.00705 10.9754 3.68028 11.4416 2.67984 12.3221C1.70561 13.1682 1.15365 14.3095 1.15365 15.5247C1.15365 16.237 1.34453 16.9046 1.70479 17.5019Z",
    stroke: "#0008C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1236 12.3063L10.1236 12.3063L10.1201 12.3033C9.12162 11.4422 7.80491 10.9754 6.40538 10.9754C3.58749 10.9754 1.15365 12.9454 1.15365 15.5247V19.6567C1.15365 22.1961 3.52826 23.9581 6.40538 23.9581C9.2825 23.9581 11.6571 22.1961 11.6571 19.6567V15.5247C11.6571 14.3079 11.1039 13.1675 10.1236 12.3063ZM6.40538 24.1976C3.18385 24.1976 0.914062 22.1787 0.914062 19.6567V15.5247C0.914062 12.9404 3.3156 10.7358 6.40538 10.7358C7.87829 10.7358 9.24708 11.2338 10.2829 12.1248C11.3332 13.0554 11.8967 14.2611 11.8967 15.5247V19.6567C11.8967 22.1787 9.62691 24.1976 6.40538 24.1976Z",
    stroke: "#0008C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6468_3881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardHoverBlue);
export default __webpack_public_path__ + "static/media/cardHoverBlue.7c59933f5e5ba90ac4ae4f9e00dc0c52.svg";
export { ForwardRef as ReactComponent };